<template>
	<div id="app">
		<div class="main" :class="$route.name">
			<!-- <div v-bind:style="styleObject" class="scale-box"> -->
			<router-view key="app" />
		</div>
	</div>
</template>

<script>
	// import debounce from "lodash.debounce"
	import DevicePixelRatio from './utils/devicePixelRatio';

	export default {
		components: {},
		props: {
			width: {
				type: Number,
				default: 1920,
			},
			height: {
				type: Number,
				default: 1080,
			},
		},
		data() {
			return {
				scale: this.getScale(),

			};
		},
		computed: {
			styleObject() {
				let obj = {
					transform: `scale(${this.scale}) translate(-50%, -50%)`,
					WebkitTransform: `scale(${this.scale}) translate(-50%, -50%)`,
					width: this.width + "px",
					height: this.height + "px",
				}
				return obj
			}

		},
		watch: {
			$route: {
				handler(newVal, oldVal) {
					// console.log( this.$route.matched)
				},
				immediate: true,
				deep: true
			},
		},
		created() {
			// this.list_zhan()
			// new DevicePixelRatio().init();
		},
		mounted() {
			this.initScale();
			this.getScale()
			this.initSessionTracking()
		},
		methods: {
			initSessionTracking() {
				const SESSION_TIMEOUT = 30 * 60 * 1000;
				const touch = () => {
					if (localStorage.getItem('token') && sessionStorage.getItem('session_active') === '1') {
						localStorage.setItem('last_activity_time', String(Date.now()));
					}
				};
				const check = () => {
					const last = Number(localStorage.getItem('last_activity_time') || 0);
					if (localStorage.getItem('token') && (!last || Date.now() - last >= SESSION_TIMEOUT)) {
						this.$store.commit('clear_vuex_user');
					}
				};
				['click', 'keydown', 'scroll', 'mousemove', 'touchstart'].forEach((event) => {
					window.addEventListener(event, touch, { passive: true });
				});
				document.addEventListener('visibilitychange', () => {
					if (document.visibilityState === 'visible') check();
				});
				window.setInterval(check, 60 * 1000);
			},
			initScale() {
				// console.log(" ************ 屏幕宽度 ************ ", document.documentElement.clientWidth);
				if (document.documentElement.clientWidth <= 768) {
					this.is_mobile = true;
				}

				// if (document && document.documentElement && document.documentElement.clientWidth) {
				//   if (document.documentElement.clientWidth < 1280) {
				//     document.querySelector("body").style.overflowX = "auto";

				//     var $target = document.querySelector('[name="viewport"]');
				//     console.log(" ********** 设置视口 ********** ", $target);
				//     document.querySelector('[name="viewport"]').setAttribute("content", "width=device-width,  initial-scale=0.15");
				//   }
				// }
			},
			getScale() {
				// 固定好16:9的宽高比，计算出最合适的缩放比，宽高比可根据需要自行更改
				// console.log(window.innerWidth,'window.innerWidth');
				let ww = window.innerWidth / this.width
				let wh = window.innerHeight / this.height
				return ww < wh ? ww : wh
			},
			// setScale: debounce(function() {

			// 	// 获取到缩放比，设置它
			// 	let scale = this.getScale()
			// 	this.scale = scale
			// 	// console.log(this.scale, "---")
			// }, 500),
		},
		beforeDestroy() {
			// window.addEventListener("resize", this.setScale)
		},
	};
</script>

<style lang="less">
#app{
   	overflow: overlay; 
	// overflow: ov;
}
div{
	word-break: break-all;

}
	.flex {
		display: flex;
		align-items: center;
	}
	.flex-between {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.flex-center {
		display: flex;
		align-items: center;
		justify-content: center;
	}














	* {
		box-sizing: border-box;
		list-style: none;
		padding: 0;
		margin: 0;
		font-family: Microsoft YaHei;
		box-sizing: border-box;
		transition: 0.1s;
	}

	html {
		width: 100%;
		height: 100%;
		// overflow-x: hidden;
		// overflow-y: hidden;
		// -webkit-appearance: none;
		// -webkit-tap-highlight-color: transparent;
	}

	.scale-box {
		transform-origin: 0 0;
		position: absolute;
		left: 50%;
		top: 50%;
		transition: 0.3s;
	}

	a {
		text-decoration: none;
	}

	.img-box {
		overflow: hidden;
	}

	img {
		object-fit: cover;
	}

	.hover {
		a:hover {
			opacity: 0.8;
		}
	}

	button {
		cursor: pointer;
	}

	input,
	textarea {
		outline: none;
		// -webkit-appearance: none;
		-webkit-tap-highlight-color: transparent;
		border: none;
		background: transparent;
		resize: none;
	}

	button,
	input,
	textarea {
		color: inherit;
		font: inherit;
		outline: none;
		border: none;

		text-indent: 0 !important;
	}

	button {
		transition: 0.3s;

		&:hover {
			opacity: 0.75;
		}
	}

	a {
		transition: 0.3s;

		&:hover {
			opacity: 0.9;
		}
	}

	img {
		vertical-align: middle;
		max-width: 100%;
	}

	.index_user_btn_list {
		width: 200px !important;

		.index_user_btns {
			display: flex;

			.index_user_btns_img {}

			.index_user_btns_text {
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: 400;
				font-size: 14px;
				color: #273A8E;
				padding-left: 10px;
			}
		}
	}

	.el_table_title {
		font-family: Microsoft YaHei, Microsoft YaHei;
		font-weight: bold;
		font-size: 14px;
		color: #333333;
		background: #EAECEE !important;
		// text-align: center;
	}

	.btn_img {
		cursor: pointer;
		width: 30px;
		text-align: center;

		img {
			width: 5px;
			height: 20px;
		}

	}

	.scope_ht_box {
		display: flex;
		align-items: center;
		cursor: pointer;
		justify-content: center;

		.imgs {
			img {
				width: 14px;
				height: 14px;
				margin-right: 10px;
			}
		}

		.text {
			font-family: Microsoft YaHei, Microsoft YaHei;
			font-weight: 400;
			font-size: 14px;
			color: #FF5E00;
		}
	}

	.daoqi_time {
		display: flex;
		align-items: center;
		justify-content: center;

		.time_text {
			font-family: Microsoft YaHei, Microsoft YaHei;
			font-weight: 400;
			font-size: 14px;
			color: #4A4A4A;
			margin-right: 9px;
		}

		.daoqi_texts_colo1 {
			font-family: Microsoft YaHei, Microsoft YaHei;
			font-weight: 400;
			font-size: 12px;
			color: #FF7440;
		}

		.daoqi_texts_colo2 {
			font-family: Microsoft YaHei, Microsoft YaHei;
			font-weight: 400;
			font-size: 12px;
			color: #FF2300;
		}
	}
	
	
	
	
	
	
	
	
	
	//  表格样式处理
	// 单元格居中
	.el-table .el-table__cell {
		text-align: center !important;
	}
	// 表头单元格边框
	.el-table--border th.el-table__cell, .el-table__fixed-right-patch {
		border-bottom: 1px solid #DBDBDB !important;
	}
	.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
		border-right: 1px solid #DBDBDB !important;
	}
	.btn_text_dr_sb{
		width: 150px;
		text-align: center;
	}
</style>

<style lang="less">
@media (max-width: 1024px) {
    html.no-trans {
        -webkit-text-size-adjust: 100%;
        body { margin: 0; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Microsoft YaHei", sans-serif; font-size: 14px; line-height: 1.6; color: #273244; background: #f5f7fa; }
        #app { overflow: visible; min-height: 100vh; min-height: 100dvh; }
        *, *::before, *::after { box-sizing: border-box; }
        div, p, a, span { word-break: normal; overflow-wrap: anywhere; }
        img, video { max-width: 100%; }
        input, select, textarea { font-size: 16px; max-width: 100%; }
        button, [role="button"], a { -webkit-tap-highlight-color: transparent; }
        button:focus-visible, a:focus-visible, [tabindex]:focus-visible {
            outline: 2px solid #377CFD;
            outline-offset: 3px;
        }
        .el-input, .el-select, .el-cascader, .el-textarea { max-width: 100%; }
        .el-input, .el-select, .el-cascader { min-height: 44px; }
        .el-select, .el-cascader { width: 100%; }
        .el-input__inner { height: 44px; line-height: 44px; padding: 0 12px; font-size: 16px; }
        // Input text must stay readable even inside deeply nested page overrides.
        input, textarea, .el-input__inner, .el-textarea__inner { font-size: 16px !important; }
        .el-input__inner { min-height: 44px; }
        .el-input__icon { line-height: 44px; width: 25px; font-size: 16px; }
        .el-textarea__inner { font-size: 16px; line-height: 1.6; min-height: 120px; padding: 12px; }
        .el-button { min-height: 44px; padding: 10px 16px; font-size: 15px; white-space: normal; }
        .el-radio, .el-checkbox { min-height: 44px; display: inline-flex; align-items: center; margin-right: 16px; }
        .el-radio__label, .el-checkbox__label { font-size: 14px; line-height: 1.6; white-space: normal; }
        .el-checkbox__inner, .el-radio__inner { width: 18px; height: 18px; }
        .el-checkbox__inner::after { left: 6px; top: 3px; }
        .el-table { max-width: 100%; font-size: 14px; }
        .el-table .cell { font-size: 14px; line-height: 1.6; padding: 8px 10px; word-break: normal; overflow-wrap: anywhere; }
        .el-table__body-wrapper { overflow-x: auto; -webkit-overflow-scrolling: touch; }
        .el-pagination { max-width: 100%; display: flex; flex-wrap: wrap; justify-content: center; padding: 8px 0; }
        .el-pagination .el-pager li, .el-pagination .btn-prev, .el-pagination .btn-next {
            min-width: 44px; height: 44px; line-height: 44px; font-size: 14px; margin: 0 2px;
        }
        .el-pagination .el-pager li.more::before { line-height: 44px; }
        .el-dialog { width: calc(100% - 32px) !important; max-width: 640px; margin: 5vh auto 24px !important; }
        .el-dialog__header { padding: 16px; }
        .el-dialog__title { font-size: 18px; line-height: 1.5; }
        .el-dialog__headerbtn { top: 4px; right: 4px; width: 44px; height: 44px; font-size: 20px; }
        .el-dialog__body { padding: 16px; font-size: 14px; max-height: 72vh; max-height: 72dvh; overflow-y: auto; }
        .el-dialog__footer { padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px)); }
        .el-message-box { width: calc(100% - 32px); max-width: 420px; }
        .el-message-box__title { font-size: 18px; }
        .el-message-box__message { font-size: 14px; }
        .el-message { min-width: 0; max-width: calc(100% - 32px); padding: 12px 16px; }
        .el-message__content { font-size: 14px; line-height: 1.6; }
        .el-select-dropdown, .el-cascader__dropdown, .el-picker-panel, .el-dropdown-menu {
            max-width: calc(100vw - 24px); font-size: 14px;
        }
        .el-select-dropdown__item, .el-dropdown-menu__item, .el-cascader-node {
            min-height: 44px; height: auto; line-height: 1.6; padding: 12px; font-size: 14px; white-space: normal;
        }
        .el-cascader-panel { max-width: calc(100vw - 24px); overflow-x: auto; font-size: 14px; }
        .el-cascader-menu { min-width: 120px; }
        .el-cascader-menu__wrap { height: 240px; }
        .el-date-picker { width: 300px; }
        .el-date-range-picker { width: 600px; max-height: 75vh; overflow: auto; }
        .el-date-range-picker__content { float: none; width: 100%; padding: 12px; }
        .el-picker-panel__content { margin: 12px; width: auto; }
        .el-date-table { font-size: 13px; }
        .el-date-table td { height: 36px; }
        .el-date-table td div { height: 36px; }
        .el-date-table td span { width: 30px; height: 30px; line-height: 30px; }
        .el-picker-panel__icon-btn { font-size: 16px; padding: 8px; }
        .el-upload { max-width: 100%; }
        .el-upload-list__item-name { white-space: normal; overflow-wrap: anywhere; }
        .el-steps { overflow-x: auto; padding-bottom: 8px; }
        .el-step { min-width: 100px; }
        .el-step__title { font-size: 14px; line-height: 1.5; }
        .el-step__description { font-size: 13px; }
        .el-carousel__arrow { width: 44px; height: 44px; font-size: 16px; }
        .el-carousel__indicator { padding: 12px 4px; }
        .el-loading-spinner .el-loading-text { font-size: 14px; }
        .no-trans .table_box { max-width: 100%; overflow-x: auto; }
        .no-trans [class*="const_const"] { overflow-x: auto; }
        .no-trans [class*="const_const"] img { height: auto; }
        .no-trans [class*="const_const"] table { min-width: 100%; }
        .no-trans .check_list_maxh { height: 44px; }
        .no-trans .pages_box { flex-wrap: wrap; gap: 8px; }
        .no-trans .pages_box > .btns { min-height: 44px; line-height: 44px; }
        .no-trans .form_flex, .no-trans .form_flex_box { flex-direction: column; align-items: stretch; gap: 8px; }
        .no-trans .form_flex > [class*="form_title"], .no-trans .form_flex > [class*="form_text"] {
            width: 100%; text-align: left; padding: 0; line-height: 1.6;
        }
        .no-trans .form_flex > [class*="input"], .no-trans .form_flex > .form_input,
        .no-trans .form_flex .inputs, .no-trans .form_flex .checks { width: 100%; min-width: 0; }
        .no-trans .btns_flex, .no-trans .btns_box { flex-wrap: wrap; gap: 12px; }
        .no-trans .btns_flex > div { min-height: 44px; line-height: 44px; }
        .no-trans .form_flex > [class*="form_title"] {
            justify-content: flex-start !important;
            text-align: left !important;
            align-items: center;
            color: #526074;
        }
        .no-trans .breadcrumb_link {
            display: inline-flex; align-items: center; min-height: 44px; min-width: 44px;
            color: #526074; text-decoration: none; cursor: pointer;
            &:active { color: #2468e8; }
            &:focus-visible { outline: 2px solid #377cfd; outline-offset: 2px; }
        }
        .no-trans .pages_box { justify-content: center; padding: 12px 0; }
        .no-trans .pages_box > .btns { min-width: 44px; padding: 10px 4px; line-height: 24px; }
        .el-input__inner, .el-textarea__inner { border-radius: 4px; border-color: #d9e1ec; color: #273244; }
        .el-input__inner::placeholder, .el-textarea__inner::placeholder { color: #8793a5; }
        .el-dialog, .el-message-box { border-radius: 6px; }
        .el-dialog__header { border-bottom: 1px solid #edf0f4; }
        .el-dialog__title { font-weight: 600; color: #273244; }
        .el-dialog__footer { border-top: 1px solid #edf0f4; }
        .el-upload-list__item .el-icon-close { display: inline-block; top: 0; right: 0; padding: 14px; min-width: 44px; min-height: 44px; }
        .no-trans .const_const, .no-trans .htmls, .no-trans .shop_consts {
            font-size: 16px; line-height: 1.85; color: #344256;
            p { margin: 0 0 16px; }
            img { max-width: 100% !important; height: auto !important; }
            video, iframe { display: block; width: 100%; max-width: 100%; aspect-ratio: ~"16 / 9"; height: auto; }
            table { display: block; max-width: 100%; overflow-x: auto; }
            a { color: #2468e8; text-decoration: underline; }
        }
    }
}
@media (prefers-reduced-motion: reduce) and (max-width: 1024px) {
    html.no-trans *, html.no-trans *::before, html.no-trans *::after { transition-duration: 0.01ms; animation-duration: 0.01ms; }
}
</style>
